// extracted by mini-css-extract-plugin
export default {"stripeLogo":"LDumRCbBACv53ciPRCpH"};